import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { DashboardBusinessesResponse, DashboardWorkspace, User } from "@/api/types";
import { transitionSession } from "@/lib/session-transition";
import { useDashboardRequest } from "./dashboard-request";

export function useDashboardBusinesses(slugOverride?: string) {
  const dashboard = useDashboardRequest(slugOverride);

  return useQuery({
    queryKey: dashboard.queryKey("businesses"),
    queryFn: () =>
      api
        .get("dashboard/businesses", dashboard.requestOptions())
        .json<DashboardBusinessesResponse>(),
    staleTime: 60_000,
  });
}

export function useSelectDashboardBusiness() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (businessId: string) =>
      api
        .patch("dashboard/selected_business", { json: { business_id: businessId } })
        .json<DashboardWorkspace>(),
    onSuccess: (_data, _variables, _result, context) => {
      transitionSession(queryClient, queryClient.getQueryData<User | null>(["me"]), context);
    },
  });
}
